import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export const contentRegisterQueryKey = ['contentRegister'];

export const contentRegisterResourceTypes = [
  'company',
  'masterActivity',
  'masterActivityTrade',
  'personnel',
  'profilePhoto',
  'trade',
  'user',
];

export function useContentRegisterQuery({ queryOptions } = {}) {
  return useQuery({
    queryKey: contentRegisterQueryKey,
    queryFn: async () => {
      const response = await axios.get('/risk_register');
      return response.data;
    },
    select: (data) =>
      formatData({ data, resourceTypes: contentRegisterResourceTypes }),
    staleTime: Infinity,
    ...queryOptions,
  });
}
